<div class="academy-catalog">
  <h1 class="academy-catalog__title">uTest Academy Course Catalog</h1>

  <div class="academy-catalog__filters">
    <ut-academy-dropdown
      dropdownLabel="Availability"
      dropdownId="availability"
      [options]="availabilityOptions"
      [model]="filters.availability"
      (onChange)="onAvailabilityChange($event)">
    </ut-academy-dropdown>
    <ut-academy-dropdown
      dropdownLabel="Progress"
      dropdownId="progress"
      [options]="progressOptions"
      [model]="filters.progress"
      (onChange)="onProgressChange($event)">
    </ut-academy-dropdown>
    <ut-academy-dropdown
      dropdownLabel="Recent Content"
      dropdownId="recentContent"
      [options]="recentContentOptions"
      [model]="filters.recentContent"
      (onChange)="onRecentContentChange($event)">
    </ut-academy-dropdown>
    <ut-academy-dropdown
      dropdownLabel="Sort by"
      dropdownId="sortBy"
      [options]="sortOptions"
      [model]="filters.sort"
      (onChange)="onSortChange($event)">
    </ut-academy-dropdown>
  </div>

  @if (isLoading) {
    <div class="academy-catalog__loading" aria-live="polite">
      <span class="sr-only">Loading learning tracks</span>
    </div>
  }

  @if (!isLoading) {
    <div>
      @if (filteredTracks.length === 0) {
        <div class="academy-catalog__empty-state" aria-live="polite">
          <h2 class="academy-catalog__empty-title">No Results Found</h2>
          <p class="academy-catalog__empty-message">No track matched your filter criteria. Try adjusting your selections or removing a filter to widen your results.</p>
        </div>
      }
      @if (filteredTracks.length > 0) {
        <div class="academy-catalog__tracks">
          @for (track of displayedTracks; track track) {
            <div
              class="academy-catalog__track-band"
              role="region"
              [attr.aria-label]="track.name"
              >
              <div class="academy-catalog__track-header">
                <div class="academy-catalog__track-info">
                  <h2 class="academy-catalog__track-name">{{ track.name }}</h2>
                  @if (track.description) {
                    <p class="academy-catalog__track-description">{{ track.description }}</p>
                  }
                </div>
                @if (track.course_tracks?.length) {
                  <ut-academy-progress-bar
                    [current]="getCompletedCount(track)"
                    [total]="track.course_tracks.length"
                    [showPercentage]="true"
                    [showLabel]="true"
                    labelSuffix="Courses"
                    height="small">
                  </ut-academy-progress-bar>
                }
              </div>
              <div class="academy-catalog__track-content">
                @if (track.course_tracks?.length) {
                  <ut-academy-track-carousel
                    [courseTracks]="track.course_tracks"
                    [learningTrackId]="track.id"
                    [enforceOrder]="track.enforce_course_track_order !== false"
                    [isAdmin]="isAdmin">
                  </ut-academy-track-carousel>
                }
              </div>
            </div>
          }
        </div>
      }
      @if (filteredTracks.length > 0) {
        <ut-academy-pagination
          [currentPage]="currentPage"
          [totalPages]="totalPages"
          (pageChange)="onPageChange($event)"
        ></ut-academy-pagination>
      }
    </div>
  }
</div>
